(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller(
        'feedbackCoordinationFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$location', '$routeParams', '$rootScope', 'Constants',
            function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $location, $routeParams, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('documentController', { $scope: $scope });
                $controller('caseNotesHistoryController', { $scope: $scope });
                $controller('complaintsHistoryController', { $scope: $scope });

                DataServices.getComplainsFeedbackUnRegistered(DataServices.responseInfo.incidentId)
                    .then(function (response) {
                        DataServices.responseInfo.ComplaintsFormData = response.data;
                        // add complaint form type to hide/show additional information button in the follow up page
                        if (response.data.templateId === Constants.ComplaintsFormType.unRegistered) {
                            DataServices.responseInfo.ComplaintsFormType = Constants.ComplaintsFormType.unRegistered;
                        } else {
                            DataServices.responseInfo.ComplaintsFormType = Constants.ComplaintsFormType.registered;
                        }
                    });

                // Default access for attaching documents
                DataServices.responseInfo.access = {
                    canSaveFile: true,
                    canViewFile: true,
                    canDeleteFile: true
                };

                // Set original response to current response as update has occurred.
                $scope.originalResponse = angular.copy($scope.responses);

                // This form is always editable, access around the other aspects on the page is governed by other conditions
                $scope.isPageEditable = true;

                var assessmentCode = 'assessment';
                var investigateCode = 'investigate';
                var respondCode = 'respond';
                var practiceImprovementCode = 'practiceimprovement';
                var additioanInfoCode = 'additionalinfo';

                $scope.configData = null;
                $scope.isLoading = true;
                $scope.discardCancelVerification = false;

                $scope.access = DataServices.responseInfo.access;

                $scope.coordinationTemplate = Constants.ConfigTemplate.feedbackCoordination;

                // Gets the followup summary details for each of the three possible followups for this incident.
                var getFollowUpSummary = function () {
                    DataServices.getFollowUpSummaryResponseAndConfig(Constants.FeedbackType.Complaint, $scope.coordinationTemplate)
                        .then(function (response) {
                            $scope.isLoading = false;
                            var data = response.data;
                            if (data) {
                                DataServices.configData = data.configData.configData;
                                DataServices.responseInfo.template = data.template;
                                DataServices.responseInfo.versionNumber = null; // reset version number to null.
                                DataServices.responseInfo.followUpVersionNumber = data.versionNo; // followup version number gets set here for subsequent pages (investigation, Notification, RA, PI)
                                DataServices.responseInfo.role = data.role;
                                DataServices.responseInfo.responses = data.responseData;
                                DataServices.responseInfo.feedbackId = data.feedbackId;
                                DataServices.responseInfo.incidentId = data.feedbackId;
                                DataServices.responseInfo.ref = data.ref;
                                DataServices.responseInfo.feedbackCaseNotes = data.feedbackCaseNotes;
                                DataServices.responseInfo.responseDueDate = data.responseDueDate;

                                DataServices.responseInfo.incidentRef = data.ref;
                                DataServices.responseInfo.statusText = data.statusDisplayName;

                                $scope.configData = DataServices.configData;
                                $scope.feedbackId = DataServices.responseInfo.feedbackId;
                                $scope.isFeedbackComplete = (data.statusId === 4 || data.statusId === 5); // Withdrawn or Closed
                                $scope.ref = DataServices.responseInfo.ref;
                                $scope.template = DataServices.responseInfo.template;
                                $scope.versionNumber = null; // reset version number to null.
                                $scope.followUpVersionNumber = data.versionNo;
                                $scope.role = DataServices.responseInfo.role;

                                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                                $scope.statusText = DataServices.responseInfo.statusText;

                                //Ability to upload and delete file even when the feedback goes to closed state
                                // Specify file access
                                DataServices.responseInfo.access.canSaveFile = !$scope.isFeedbackComplete || data.statusId === Constants.Status.Closed;
                                DataServices.responseInfo.access.canDeleteFile = !$scope.isFeedbackComplete || data.statusId === Constants.Status.Closed;

                                // Reset the document list before adding what we have retrieved
                                $scope.responses.documents = [];

                                data.feedbackDocuments.forEach(function (doc) {
                                    var uploadedDoc = {
                                        documentId: doc.id,
                                        name: doc.name,
                                        incidentId: DataServices.responseInfo.feedbackId,
                                        isDeleteDisabled: !doc.canDeleteFile,
                                        isDocUploaded: true,
                                        size: doc.size,
                                        uploadDateTime: new Date(doc.createdTime).toLocaleString('en-AU', { day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
                                    };
                                    $scope.responses.documents.push(uploadedDoc);
                                });

                                DataServices.responseInfo.responses.documents = $scope.responses.documents;
                                if ($scope.responses.documents.length > 0) {
                                    $scope.initPageAttachments();
                                }

                                $scope.responses = data.responseData;
                                $scope.getHistory();

                                // Retrieve the history only when loading the history tab
                                if ($location.$$path.slice(1) === Constants.Url.secondFeedbackCoordinationFormPage) {
                                    $scope.initComplainHistory();
                                }

                                $scope.setupTriggersAndDynamicValues();
                                document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                            }
                            else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        });
                }

                $scope.addFollowUpAction = function (sectionCode, buttonText) {

                    // Do nothing if the feedback is already in a final state
                    if ($scope.isFeedbackComplete) {
                        return;
                    }

                    var template;
                    var nextPage;
                    var templateVersion;
                    var getConfigDataFromCache = true;
                    switch (sectionCode) {
                        case assessmentCode:
                            template = Constants.ConfigTemplate.feedbackAssessment;
                            nextPage = Constants.Url.firstFeedbackAssessmentFormPage;
                            $scope.isLoadingAssessment = true;
                            if (DataServices.maxTemplateVersions.feedbackAssessment == 0) {
                                getConfigDataFromCache = false;
                            }
                            else {
                                templateVersion = DataServices.maxTemplateVersions.feedbackAssessment;
                            }
                            break;

                        case additioanInfoCode:
                            template = Constants.ConfigTemplate.feedbackAdditionalInfo;
                            nextPage = Constants.Url.firstFeedbackAdditionalInfoFormPage
                            $scope.isLoadingAdditionalInfo = true;
                            if (DataServices.maxTemplateVersions.feedbackAdditionalInfo == 0) {
                                getConfigDataFromCache = false;
                            }
                            else {
                                templateVersion = DataServices.maxTemplateVersions.feedbackAdditionalInfo;
                            }
                            break;

                        case investigateCode:
                            template = Constants.ConfigTemplate.feedbackInvestigate;
                            nextPage = Constants.Url.firstFeedbackInvestigateFormPage
                            $scope.isLoadingInvestigate = true;
                            if (DataServices.maxTemplateVersions.feedbackInvestigate == 0) {
                                getConfigDataFromCache = false;
                            }
                            else {
                                templateVersion = DataServices.maxTemplateVersions.feedbackInvestigate;
                            }
                            break;

                        case respondCode:
                            template = Constants.ConfigTemplate.feedbackRespond;
                            nextPage = Constants.Url.firstFeedbackRespondFormPage
                            $scope.isLoadingRespond = true;
                            if (DataServices.maxTemplateVersions.feedbackRespond == 0) {
                                getConfigDataFromCache = false;
                            }
                            else {
                                templateVersion = DataServices.maxTemplateVersions.feedbackRespond;
                            }
                            break;

                        case practiceImprovementCode:
                            template = Constants.ConfigTemplate.feedbackPracticeImprovement;
                            nextPage = Constants.Url.firstFeedbackPracticeImprovementFormPage
                            $scope.isLoadingPracticeImprovement = true;
                            if (DataServices.maxTemplateVersions.feedbackPracticeImprovement == 0) {
                                getConfigDataFromCache = false;
                            }
                            else {
                                templateVersion = DataServices.maxTemplateVersions.feedbackPracticeImprovement;
                            }
                            break;
                    }

                    DataServices.isFollowUpEditable = true;

                    if (!getConfigDataFromCache) {
                        DataServices.getConfiguration(template, null, null, DataServices.isAuthenticated())
                            .then(function (data) {

                                $scope.isLoadingAssessment = false;
                                $scope.isLoadingInvestigate = false;
                                $scope.isLoadingRespond = false;
                                $scope.isLoadingPracticeImprovement = false;
                                $scope.isLoadingAdditionalInfo = false;

                                if (data) {

                                    DataServices.responseInfo.followUpId = null; // reset followup id for add.
                                    DataServices.responseInfo.template = data.template;

                                    switch (DataServices.responseInfo.template) {

                                        case Constants.ConfigTemplate.feedbackAssessment:
                                            DataServices.maxTemplateVersions.feedbackAssessment = data.versionNumber;
                                            break;
                                        case Constants.ConfigTemplate.feedbackAdditionalInfo:
                                            DataServices.maxTemplateVersions.feedbackAdditionalInfo = data.versionNumber;
                                            break;
                                        case Constants.ConfigTemplate.feedbackInvestigate:
                                            DataServices.maxTemplateVersions.feedbackInvestigate = data.versionNumber;
                                            break;
                                        case Constants.ConfigTemplate.feedbackRespond:
                                            DataServices.maxTemplateVersions.feedbackRespond = data.versionNumber;
                                            break;
                                        case Constants.ConfigTemplate.feedbackPracticeImprovement:
                                            DataServices.maxTemplateVersions.feedbackPracticeImprovement = data.versionNumber;
                                            break;

                                    }

                                    DataServices.responseInfo.versionNumber = data.versionNumber;
                                    DataServices.responseInfo.role = data.role;
                                    DataServices.responseInfo.responses = {};

                                    DataServices.responseInfo.spStatus = Constants.FollowUpStatus.draft;
                                    DataServices.responseInfo.spStatusText = 'Draft'; // default for new.
                                    DataServices.responseInfo.frStatus = 0; // reset
                                    DataServices.responseInfo.frStatusText = ''; // reset
                                    DataServices.responseInfo.incidentFRStatus = 0; // reset
                                    DataServices.validationErrors = [];
                                    DataServices.configData = data.configData;
                                    $scope.configData = DataServices.configData;

                                    DataServices.pushConfigData(data.configData, template, data.versionNumber, data.role);
                                    DataServices.trackEventsWithGA('PageName: Complaint Coordination', 'Click ' + buttonText, buttonText);
                                    $location.path(nextPage);

                                } else {
                                    $scope.utility.showNotification(true, 'internalError');
                                }
                            }, function (data) {
                                $scope.utility.showNotification(true, 'internalError');
                            });

                    }
                    else {
                        DataServices.getConfigurationUsingCache(template, templateVersion, null, DataServices.isAuthenticated())
                            .then(function (data) {

                                $scope.isLoadingAssessment = false;
                                $scope.isLoadingInvestigate = false;
                                $scope.isLoadingRespond = false;
                                $scope.isLoadingPracticeImprovement = false;
                                $scope.isLoadingAdditionalInfo = false;

                                if (data) {

                                    DataServices.responseInfo.followUpId = null; // reset followup id for add.
                                    DataServices.responseInfo.template = data.template;
                                    DataServices.responseInfo.versionNumber = data.versionNumber;
                                    DataServices.responseInfo.role = data.role;
                                    DataServices.responseInfo.responses = {};

                                    DataServices.responseInfo.spStatus = Constants.FollowUpStatus.draft;
                                    DataServices.responseInfo.spStatusText = 'Draft'; // default for new.
                                    DataServices.responseInfo.frStatus = 0; // reset
                                    DataServices.responseInfo.frStatusText = ''; // reset
                                    DataServices.responseInfo.incidentFRStatus = 0; // reset
                                    DataServices.validationErrors = [];
                                    DataServices.configData = data.configData;
                                    $scope.configData = DataServices.configData;

                                    DataServices.pushConfigData(data.configData, template, data.versionNumber, data.role);
                                    DataServices.trackEventsWithGA('PageName: Complaint Coordination', 'Click ' + buttonText, buttonText);
                                    $location.path(nextPage);

                                } else {
                                    $scope.utility.showNotification(true, 'internalError');
                                }
                            }, function (data) {
                                $scope.utility.showNotification(true, 'internalError');
                            });
                    }
                }

                // Opens an existing followup action for Edit / View
                $scope.openFollowUpAction = function (template, followUpId) {
                    if (template == Constants.ConfigTemplate.feedbackAssessment) {
                        $scope.isLoadingAssessment = true;
                    }
                    else if (template == Constants.ConfigTemplate.feedbackInvestigate) {
                        $scope.isLoadingInvestigate = true;
                    }
                    else if (template == Constants.ConfigTemplate.feedbackRespond) {
                        $scope.isLoadingRespond = true;
                    }
                    else if (template == Constants.ConfigTemplate.feedbackPracticeImprovement) {
                        $scope.isLoadingPracticeImprovement = true;
                    }
                    else if (template == Constants.ConfigTemplate.feedbackAdditionalInfo) {
                        $scope.isLoadingAdditionalInfo = true;
                    }

                    DataServices.getFollowUpResponseAndConfig(followUpId, Constants.FeedbackType.Complaint)
                        .then(function (response) {
                            if (template == Constants.ConfigTemplate.feedbackAssessment) {
                                $scope.isLoadingAssessment = false;
                            }
                            else if (template == Constants.ConfigTemplate.feedbackInvestigate) {
                                $scope.isLoadingInvestigate = false;
                            }
                            else if (template == Constants.ConfigTemplate.feedbackRespond) {
                                $scope.isLoadingRespond = false;
                            }
                            else if (template == Constants.ConfigTemplate.feedbackPracticeImprovement) {
                                $scope.isLoadingPracticeImprovement = false;
                            }
                            else if (template == Constants.ConfigTemplate.feedbackAdditionalInfo) {
                                $scope.isLoadingAdditionalInfo = false;
                            }

                            var data = response.data;
                            if (data) {

                                DataServices.responseInfo.access = data.access;

                                DataServices.responseInfo.status = data.statusId;

                                DataServices.responseInfo.incidentRef = data.ref;
                                DataServices.responseInfo.statusText = data.statusDisplayName;

                                DataServices.responseInfo.followUpId = followUpId;
                                DataServices.responseInfo.template = data.template
                                DataServices.responseInfo.versionNumber = data.versionNo;
                                DataServices.responseInfo.role = data.role;
                                DataServices.responseInfo.lastUpdatedTime = data.lastUpdatedTime;
                                DataServices.validationErrors = [];
                                DataServices.configData = data.configData.configData;
                                $scope.configData = DataServices.configData;
                                DataServices.pushConfigData(data.configData.configData, template, data.versionNo, data.role);

                                if (template == Constants.ConfigTemplate.feedbackAssessment ||
                                    template == Constants.ConfigTemplate.feedbackRespond) {
                                    if (data.role.includes(Constants.Role.FMS_Admin) && data.role.includes(Constants.Role.ComplaintsManager)) {
                                        DataServices.isFollowUpEditable = true;
                                    }
                                    else if (data.role.includes(Constants.Role.FMS_ComplaintsAdmin)) {
                                        DataServices.isFollowUpEditable = true;
                                    }
                                    else {
                                        DataServices.isFollowUpEditable = $scope.isFeedbackComplete === false;
                                    }
                                }
                                else {
                                    if (data.role.includes(Constants.Role.FMS_Admin) && data.role.includes(Constants.Role.ComplaintsManager)) {
                                        DataServices.isFollowUpEditable = true;
                                    }
                                    else if (data.role.includes(Constants.Role.FMS_ComplaintsAdmin)) {
                                        DataServices.isFollowUpEditable = true;
                                    }
                                    else {
                                        DataServices.isFollowUpEditable = (data.statusId !== Constants.FollowUpStatus.submitted && $scope.isFeedbackComplete === false);
                                    }
                                }

                                DataServices.responseInfo.responses = data.responseData;
                                $scope.responses = DataServices.responseInfo.responses;

                                switch (template) {
                                    case Constants.ConfigTemplate.feedbackAdditionalInfo:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Feedback Assessment', 'Edit/View Feedback Additional Information');
                                        $location.path(Constants.Url.firstFeedbackAdditionalInfoFormPage);
                                        break;
                                    case Constants.ConfigTemplate.feedbackAssessment:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Feedback Assessment', 'Edit/View Feedback Assessment');
                                        $location.path(Constants.Url.firstFeedbackAssessmentFormPage);
                                        break;
                                    case Constants.ConfigTemplate.feedbackInvestigate:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Feedback Investigate', 'Edit/View Feedback Investigate');
                                        $location.path(Constants.Url.firstFeedbackInvestigateFormPage);
                                        break;
                                    case Constants.ConfigTemplate.feedbackRespond:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Feedback Response', 'Edit/View Feedback Response');
                                        $location.path(Constants.Url.firstFeedbackRespondFormPage);
                                        break;
                                    case Constants.ConfigTemplate.feedbackPracticeImprovement:
                                        DataServices.trackEventsWithGA('PageName: ManageFollowUpActions', 'Click View/Edit Feedback Practice Improvement', 'Edit/View Feedback Practice Improvement');
                                        $location.path(Constants.Url.firstFeedbackPracticeImprovementFormPage);
                                        break;
                                }
                            } else {
                                $scope.utility.showNotification(true, 'internalError');
                            }
                        });
                }

                $scope.checkValueChangeForCoordinationPage = function () {
                    if ($scope.discardCancelVerification) {
                        return false;
                    }
                    return $scope.notEmpty(null, 'fcCaseNote', 'caseNote', 0, 0, '1-1');
                }

                $scope.callCancelFollowUp = function () {
                    $scope.cancel();
                }

                $scope.cancel = function () {
                    if (!$scope.notEmpty(null, 'fcCaseNote', 'caseNote', 0, 0, '1-1')) {
                        $location.path(Constants.Url.manageComplaints);
                    } else {
                        $scope.utility.openPopup('warnUserBeforeCancel').result.then(
                            function (data) {
                                if (data.result == "thirdButtonClick") {
                                    $scope.saveFeedbackCaseNotes().then(function () {
                                        $location.path(Constants.Url.manageComplaints);
                                    });
                                }
                                else {
                                    $scope.discardCancelVerification = true;
                                    $location.path(Constants.Url.manageComplaints);
                                }
                            });
                    }
                }

                $scope.saveAndReturnToLanding = function () {
                    if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {
                        // Case Note is not mandatory, and therefore we need to ignore when they submit an empty text field 
                        if (!$scope.notEmpty(null, 'fcCaseNote', 'caseNote', 0, 0, '1-1')) {
                            $location.path(Constants.Url.manageComplaints);
                        }
                        else {
                            $scope.isSaving = true;
                            $scope.saveFeedbackCaseNotes().then(function () {
                                $location.path(Constants.Url.manageComplaints);
                            });
                        }
                    }
                    else {
                        $scope.alertFirstError();
                    }
                }

                $scope.saveFeedbackCaseNotes = function () {
                    return DataServices.saveFeedbackCaseNotes()
                        .then(function (response) {
                            if (response.data) {
                                if (response.data.status === 3) {
                                    DataServices.trackEventsWithGA('Save action in ' + $scope.pageUrl, 'Click Save Feedback Case Notes And Documents', 'Successfully Saved Feedback Case Notes And Documents');
                                    $scope.originalResponse = angular.copy($scope.responses);
                                    $scope.discardCancelVerification = true;
                                    return $scope.utility.openPopup('submissionSuccessMessage').result;
                                } else {
                                    DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl, 'Click  Save Feedback Case Notes And Documents', 'Failed to  Save Feedback Case Notes And Documents');
                                    return $scope.utility.openPopup('submissionFailureMessage').result;
                                }
                            }
                            else {
                                return $scope.utility.showNotification(true, 'internalError', null, true);
                            }
                        }, function (response) {
                            DataServices.trackEventsWithGA('Error occured during Save in ' + $scope.pageUrl, 'Click  Save Feedback Case Notes And Documents', 'Failed to  Save Feedback Case Notes And Documents');
                            return $scope.utility.openPopup('submissionFailureMessage').result;
                        })
                        .finally(function () {
                            $scope.isSaving = false;
                        });
                }

                $scope.getComplaintType = function () {
                    return DataServices.responseInfo.ComplaintsFormType;

                };

                getFollowUpSummary();
            }]);
}());